import { render, staticRenderFns } from "./ManagerWelcome.vue?vue&type=template&id=3d04482c&scoped=true"
import script from "./ManagerWelcome.vue?vue&type=script&lang=js"
export * from "./ManagerWelcome.vue?vue&type=script&lang=js"
import style0 from "./ManagerWelcome.vue?vue&type=style&index=0&id=3d04482c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d04482c",
  null
  
)

export default component.exports